const SEGMENT_AVATARS = [
  '/images/avatar-presets/avatar_shawn.png',
  '/images/avatar-presets/avatar_ann.png',
  '/images/avatar-presets/avatar_dexter.png',
  '/images/avatar-presets/avatar_judy.png',
  '/images/avatar-presets/avatar_amina.png',
  '/images/avatar-presets/avatar_anthony.png',
  '/images/avatar-presets/avatar_rika.png',
  '/images/avatar-presets/avatar_anastasia.png',
  '/images/avatar-presets/avatar_marianne.png',
  '/images/avatar-presets/avatar_billy.png',
  '/images/avatar-presets/avatar_nicole.png',
  '/images/avatar-presets/avatar_susan.png',
  '/images/avatar-presets/avatar_chris.png',
  '/images/avatar-presets/avatar_jerry.png',
  '/images/avatar-presets/avatar_elaine.png',
];

export function getSegmentAvatar(index: number): string {
  return SEGMENT_AVATARS[index % SEGMENT_AVATARS.length];
}

/**
 * Return a fresh Fisher-Yates shuffle of the avatar preset list. Callers use
 * this at segment-save time to assign each segment a unique avatar per run —
 * the first N ≤ SEGMENT_AVATARS.length segments are guaranteed distinct.
 *
 * Non-deterministic on purpose: each call yields a new ordering so two runs
 * don't pattern-match. The chosen iconUrl is persisted to the DB, so render
 * paths that prefer seg.iconUrl surface the stored choice stably.
 */
export function shuffleSegmentAvatars(): string[] {
  const out = SEGMENT_AVATARS.slice();
  for (let i = out.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [out[i], out[j]] = [out[j], out[i]];
  }
  return out;
}
